export default {
  wrapper: {
    base: {
      variant: 'spark.base.wrapper'
    },
    variants: {
      sm: {
        variant: 'spark.element.spinner.wrapper.base'
      },
      md: {
        variant: 'spark.element.spinner.wrapper.base'
      },
      lg: {
        variant: 'spark.element.spinner.wrapper.base'
      },
      xl: {
        variant: 'spark.element.spinner.wrapper.base'
      }
    }
  },
  spinner: {
    base: {},
    variants: {
      sm: {
        height: '24px',
        width: '24px',
        variant: 'spark.element.spinner.spinner.base'
      },
      md: {
        height: '32px',
        width: '32px',
        variant: 'spark.element.spinner.spinner.base'
      },
      lg: {
        height: '48px',
        width: '48px',
        variant: 'spark.element.spinner.spinner.base'
      },
      xl: {
        height: '96px',
        width: '96px',
        variant: 'spark.element.spinner.spinner.base'
      }
    }
  },
  circleBg: {
    base: {
      strokeWidth: '30px',
      stroke: 'grey-10'
    },
    variants: {
      sm: {
        variant: 'spark.element.spinner.circleBg.base'
      },
      md: {
        variant: 'spark.element.spinner.circleBg.base'
      },
      lg: {
        variant: 'spark.element.spinner.circleBg.base'
      },
      xl: {
        variant: 'spark.element.spinner.circleBg.base'
      }
    }
  },
  circleSpin: {
    base: {
      strokeWidth: '30px',
      stroke: 'blue'
    },
    variants: {
      sm: {
        variant: 'spark.element.spinner.circleSpin.base'
      },
      md: {
        variant: 'spark.element.spinner.circleSpin.base'
      },
      lg: {
        variant: 'spark.element.spinner.circleSpin.base'
      },
      xl: {
        variant: 'spark.element.spinner.circleSpin.base'
      }
    }
  }
};